<template>
  <div>
    <div class="bg">
      <div class="box">
        <div class="router_box">
          <div class="left">
            <img src="../../assets/stylus/image/logo_2.png" />
            <div class="router_home" @click="menu_router('/edit_home')">
              首页
            </div>
            <div class="router_homes" @click="menu_router('/contest')">
              赛事
            </div>
          </div>
          <div class="right">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <img src="../../assets/stylus/image/head.png" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="我的项目">我的项目</el-dropdown-item>
                <el-dropdown-item command="logoOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

    <ul class="list_ul">
      <li>
        <div class="top">
          <img src="../../assets/stylus/image/mr.jpeg" />
        </div>
        <div class="bottom">
          <a>首届自治区青少年创意编程与智能设计大赛</a>
          <p style="margin-top:14px;">主办单位：程果少儿编程</p>
          <p>申报时间：2021年9月12日 - 2021年10月12日</p>

          <div class="but_div">
            <el-button type="primary" size="mini" @click="to_router"
              >查看赛事详情</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="to_router('popularity')"
              >查看人气榜</el-button
            >
          </div>
        </div>
      </li>
      <li>
        <div class="top">
          <img src="../../assets/stylus/image/mr.jpeg" />
        </div>
        <div class="bottom">
          <a>首届自治区青少年创意编程与智能设计大赛</a>
          <p style="margin-top:14px;">主办单位：程果少儿编程</p>
          <p>申报时间：2021年9月12日 - 2021年10月12日</p>

          <div class="but_div">
            <el-button type="primary" size="mini">查看赛事详情</el-button>
            <el-button type="danger" size="mini">查看人气榜</el-button>
          </div>
        </div>
      </li>
      <li>
        <div class="top">
          <img src="../../assets/stylus/image/mr.jpeg" />
        </div>
        <div class="bottom">
          <a>首届自治区青少年创意编程与智能设计大赛</a>
          <p style="margin-top:14px;">主办单位：程果少儿编程</p>
          <p>申报时间：2021年9月12日 - 2021年10月12日</p>

          <div class="but_div">
            <el-button type="primary" size="mini" @click="to_router"
              >查看赛事详情</el-button
            >
            <el-button type="danger" size="mini">
              查看人气榜
            </el-button>
          </div>
        </div>
      </li>
    </ul>
    <fotter></fotter>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { logonOut } from "@/api/login.js";
import store from "../../store";
import fotter from "../components/fotter.vue";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    fotter,
  },
  data() {
    return {
      scratch_list: [],
      tag: "",
    };
  },

  created() {},

  methods: {
    my_project() {
      this.$router.push({ path: "/my_works" });
    },

    start_writing() {
      var url = "/scratch/?stageArea=false";
      window.open(url);
    },

    menu_router(item) {
      this.$router.push({ path: item });
    },

    handleCommand(item) {
      if (item == "我的项目") {
        this.$router.push({ path: "/my_works" });
      } else {
        logonOut().then(() => {
          this.$router.push({ path: "/" });
          window.sessionStorage.clear();
          store.dispatch("user/userInfo", {});
        });
      }
    },

    to_router(type) {
      if (type == "popularity") {
        this.$router.push({
          path: "/contest_details",
          query: { type: "popularity" },
        });
      } else {
        this.$router.push({ path: "/contest_details" });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.bg {
    background:#ffb000;
    width:100%;

  .box {
     width:86%;
     padding:12px;
     margin:0 auto;

     .router_box {
       width:100%;
       display:flex;
       justify-content:space-between;

       .left {
          width:26%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width:130px;
            margin-right:30px;
          }

          .router_home {
              color: white;
              font-size:14px;
              cursor: pointer;
              padding: 10px 20px;
              border-radius: 20px;
          }

          .router_homes {
              color: white;
              font-size:14px;
              cursor: pointer;
              padding: 10px 20px;
              background: #d59504;
              border-radius: 20px;
          }

          .router_home:hover {
            padding: 10px 20px;
            background: #d59504;
            border-radius: 20px;

          }
       }

       .right {
          img {
            width:30px;
          }
          img:hover {
              cursor: pointer;
          }
       }
     }
  }
}

.el-dropdown {
    position: relative;
    top:50%;
    transform:translateY(-50%);
}

.list_ul {
     width:86%;
     padding:0 12px 30px 12px;
	 box-sizing: border-box;
     margin:0 auto;
     display:flex;
     flex-wrap:wrap;
     justify-content:space-between;
     li {
         width: 49%;
         background:#4172ec;
         margin-top:20px;
         height: 480px;
         background-color: #fff;
         border-radius: 6px;
         transition: all 0.3s ease;
         overflow:hidden;
         cursor: pointer;
    .top {
        height:64%;
        background:#39A5EF;
        overflow:hidden
        img {
            height:100%;
        }
    }
    .bottom {
        height:36%;
        background:#fff;
        padding:20px;
        a {
    display: -webkit-box;
    width: 400px;
    -webkit-box-orient: vertical;
    color: #333;
    font-size: 18px;
    -webkit-line-clamp: 2;
    line-height: 25px;
    overflow: hidden;

        }

        p {
            width: 400px;
    color: #666;
    font-size: 14px;
    line-height: 20px;
    margin-top: 6px;
        }

        .but_div {
            margin-top:20px;
            float:right;
        }
    }
}

li:hover {
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

}
</style>
